import { render, staticRenderFns } from "./OrderCotizationNew.vue?vue&type=template&id=5d0515c2&"
import script from "./OrderCotizationNew.vue?vue&type=script&lang=js&"
export * from "./OrderCotizationNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports